import { useIntl } from 'react-intl';

import type { VitaDocumentThemeColor } from '@xing-com/crate-common-graphql-types';
import { COLORS } from '@xing-com/crate-lebenslauf-constants';
import {
  useVitaReactiveVariableActions,
  useReadVitaReactiveVariable,
  useCoverLetterActions,
  useIsCoverLetterEditor,
  useReadCoverLetter,
} from '@xing-com/crate-lebenslauf-hooks';

import { Wrapper, Button, Marked } from './color-picker.styled';

export type ColorPickerProps = { className?: string };

export const ColorPicker: React.VFC<ColorPickerProps> = ({ className }) => {
  const { theme } = useReadVitaReactiveVariable();
  const coverLetter = useReadCoverLetter();
  const { themeActions } = useVitaReactiveVariableActions();
  const isCoverLetterEditor = useIsCoverLetterEditor();
  const { coverLetterThemeActions } = useCoverLetterActions();
  const { formatMessage } = useIntl();

  const handleOnClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    colorName: VitaDocumentThemeColor
  ): void => {
    e.preventDefault();
    const action = { type: 'change-color' as const, value: colorName };
    isCoverLetterEditor
      ? coverLetterThemeActions(action)
      : themeActions(action);
  };

  const color = isCoverLetterEditor ? coverLetter.theme?.color : theme?.color;

  return (
    <Wrapper className={className}>
      {Object.entries(COLORS).map(([name, colors], index) => {
        return (
          <Button
            key={name}
            $primary={colors.primary}
            $secondary={colors.secondary}
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onClick={(e) => handleOnClick(e, name as VitaDocumentThemeColor)}
            aria-label={formatMessage(
              {
                id: 'CRATE_LEBENSLAUF_COLOR_PICKER',
              },
              {
                color: index + 1,
              }
            )}
          >
            {color === name ? <Marked height={24} /> : null}
          </Button>
        );
      })}
    </Wrapper>
  );
};
